import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'cleaned-location' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
